window.anvil.block('rutinas', el => {
    let blockID = el.dataset.blockId;
    const programButtons = document.querySelectorAll('[data-block-id="' + blockID + '"] .js-program-button');

    const daysPanelCloseBtn = document.querySelectorAll('[data-block-id="' + blockID + '"] .js-days-panel-close-btn');

    programButtons.forEach( button => {
        button.addEventListener( 'click', e => {
            const programPanel = button.dataset.programTrigger;
            const daysPanel = document.getElementById(programPanel);
            document.querySelector('[data-program-print="' + programPanel + '"]').classList.add( 'active' );
            daysPanel.classList.add( 'active' );
        });
    });

    daysPanelCloseBtn.forEach( closebtn => {
        closebtn.addEventListener( 'click', e => {
            const backBtn = e.target.dataset.programBack;
            document.querySelector('[data-program-print="' + backBtn + '"]').classList.remove( 'active' );
            document.getElementById(backBtn).classList.remove( 'active' );
        });
    });

    const dayBtn = document.querySelectorAll('[data-block-id="' + blockID + '"] .js-day-button');
    const workoutPanelCloseBtn = document.querySelectorAll('[data-block-id="' + blockID + '"] .js-workout-panel-close-btn');
    const workoutPanel = document.querySelectorAll('[data-block-id="' + blockID + '"] .js-workout-panel');

    dayBtn.forEach( button => {
        button.addEventListener( 'click', function(e) {
            let dayPanel = document.querySelector('[data-block-id="' + blockID + '"] ' + '.' + this.dataset.clickDay ); 
            dayPanel.classList.add( 'active' );
        });
    });

    workoutPanelCloseBtn.forEach( closeBtn => {
        closeBtn.addEventListener( 'click', e => {
            workoutPanel.forEach( panel => {
                panel.classList.remove( 'active' );
            });
        });
    });

    // Video Player
    const videoBtn = document.querySelectorAll('[data-block-id="' + blockID + '"] .js-video-btn');
    const videoPanelCloseBtn = document.querySelectorAll('[data-block-id="' + blockID + '"] .js-video-panel-close-btn');
    const videoPanel = document.querySelectorAll('[data-block-id="' + blockID + '"] .js-video-panel');

    // Button Close Video
    videoPanelCloseBtn.forEach( closeBtn => {
        closeBtn.addEventListener( 'click', e => {
            videoPanel.forEach( panel => {
                onPauseVideo(panel);
                panel.classList.remove( 'active' );
            });
        });
    });

    // Button Open Video 
    videoBtn.forEach( function( button ) {
        button.addEventListener( 'click', function(e) {

            let videoPanel = document.querySelector('[data-block-id="' + blockID + '"] ' + '.' + this.dataset.clickVideo ); 
            videoPanel.classList.add( 'active' );

            onPlayVideo(button);
        });
    });

    const onPlayVideo = playBtn => {
        iframeObjects.forEach( player => {
            if ( player.g.dataset.videoId == playBtn.dataset.videoCount ) {
                setTimeout( () => {
                    player.playVideo();
                },300);
            }
        });
    };
    
    const onPauseVideo = panel => {
        if ( panel.classList.contains( 'active' ) ) {
            let videoPanelId = panel.querySelector('.youtube-player').dataset.videoId;
            iframeObjects.forEach(player => {
                if ( player.g.dataset.videoId == videoPanelId ) {
                    player.pauseVideo();
                }
            });
        };
    };

    // ---------------------------------------------------------------------// 
    // Init empty array of iframe IDs, one from each video
    let iframeIds = [];

    // For each iframe you find, add its ID to the iframeIds array
    let iframes = document.querySelectorAll('.youtube-player');

    iframes.forEach(function(iframe) {
        iframeIds.push( iframe.dataset.videoId );
    });

    // Once the YouTube API is ready, for each iframeId in your array, create
    // a new YT player and give it the onReady event
    window.onYouTubeIframeAPIReady = () =>  {
        iframeIds.forEach(iframeId => {
            
            new YT.Player(iframeId, {
                events: {
                    onReady: onPlayerReady
                }
            });
        });
    };
    
    // Init empty array of iframe YT objects for use elsewhere
    // Here I only use this to iterate through and pause all videos when
    // another begins playing
    let iframeObjects = [];

    // Shared onReady event which adds events to each video's corresponding
    // play and stop buttons
    function onPlayerReady(event) {
        let iframeObject = event.target;

        // Push current iframe object to array
        iframeObjects.push(iframeObject);
    }
    
    // Inject YouTube API script
    let tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/player_api';
    let firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // Add Print Style
    let styleTag = document.createElement('link');
    styleTag.href = '/wp-content/themes/novofitclub/style-print-workouts.css';
    styleTag.media = 'print';
    styleTag.rel = 'stylesheet';
    let firstStyleTag = document.getElementsByTagName('link')[0];
    firstStyleTag.parentNode.insertBefore(styleTag, firstStyleTag);

    /**
     * Prevents the mobile browser behaviour that moves to the next or previous page
     * in your browser's history when you swipe in from the edge of the screen.
     *
     * Only seems to work reliably on Safari. Testing on Chrome iOS showed 
     * inconsistent effectiveness. Did not test other browsers.
     *
     * @returns A function to call to resume the browser's normal behaviour.
     */
    // function preventBrowserHistorySwipeGestures() {
    //     function touchStart(ev) {
    //     if (ev.touches.length === 1) {
    //         const touch = ev.touches[0];
    //         if (
    //         touch.clientX < window.innerWidth * 0.1 ||
    //         touch.clientX > window.innerWidth * 0.4
    //         ) {
    //         ev.preventDefault();
    //         }
    //     }
    //     }
    
    //     // Safari defaults to passive: true for the touchstart event, so we need  to explicitly specify false
    //     // See https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
    //     const options= { passive: false };
    
    //     window.addEventListener('touchstart', touchStart, options);
    
    //     return () => window.removeEventListener('touchstart', touchStart, options);
    // }

    // // Prevent edge swipes
    // preventBrowserHistorySwipeGestures();

    // function DisableBackButton(){
    //     window.history.forward();
    // }
    // DisableBackButton();
    // window.onload = DisableBackButton;
    // window.onpageshow = function(evt) { if (evt.persisted) DisableBackButton(); };
    // window.onload = function() {void(0);};
});

